import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "../lib/api";

import { logger } from "../lib/log";
const NotificationsBell = () => {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const dropRef = useRef(null);

  const refresh = async () => {
    try {
      const r = await api.get("/notifications/unread-count");
      setCount(r.data.count);
    } catch (e) { logger.warn("[notif count]", e?.message); }
  };
  const loadList = async () => {
    try {
      const r = await api.get("/notifications?limit=15");
      setItems(r.data);
    } catch (e) { logger.warn("[notif list]", e?.message); }
  };

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 45000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onDoc = (e) => { if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const toggle = async () => {
    if (!open) await loadList();
    setOpen(!open);
  };

  const markAll = async () => {
    await api.post("/notifications/read-all");
    setCount(0);
    setItems((s) => s.map((n) => ({ ...n, read: true })));
  };

  const clickOne = async (n) => {
    if (!n.read) {
      await api.post(`/notifications/${n.id}/read`);
      setCount((c) => Math.max(0, c-1));
      setItems((s) => s.map((x) => x.id === n.id ? { ...x, read: true } : x));
    }
  };

  return (
    <div className="relative" ref={dropRef}>
      <button data-testid="notif-bell" onClick={toggle} className="relative p-2 hover:bg-black/5 transition-colors rounded-full">
        <Bell className="w-4 h-4"/>
        {count > 0 && (
          <span data-testid="notif-count" className="absolute -top-0.5 -right-0.5 bg-[color:var(--accent)] text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-mono">
            {count > 9 ? "9+" : count}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-12 w-96 bg-white border border-black/10 shadow-xl z-50">
          <div className="flex items-center justify-between p-4 border-b border-black/10">
            <div className="font-mono-eyebrow">Notifications</div>
            {count > 0 && <button data-testid="notif-mark-all" onClick={markAll} className="editorial-link font-mono-eyebrow text-[10px]">Mark all read</button>}
          </div>
          <div className="max-h-96 overflow-y-auto">
            {items.length === 0 ? (
              <div className="p-10 text-center font-mono-eyebrow text-black/40">A quiet week — no notifications yet.</div>
            ) : (
              items.map((n) => (
                <Link key={n.id} to={`/outfits/${n.outfit_slug}`} onClick={()=>{clickOne(n); setOpen(false);}}
                  data-testid={`notif-${n.id}`}
                  className={`block px-4 py-3 border-b border-black/5 hover:bg-[#F1EFE7] transition-colors ${n.read ? "" : "bg-[#F6F5F1]"}`}>
                  <div className="flex gap-3">
                    {!n.read && <span className="mt-1.5 w-2 h-2 rounded-full bg-[color:var(--accent)] shrink-0"/>}
                    <div className="flex-1 min-w-0">
                      <div className="text-sm">
                        <span className="font-medium">{n.actor_name}</span>
                        <span className="text-black/60"> remixed your look </span>
                        <span className="font-serif-display italic">"{n.outfit_name}"</span>
                      </div>
                      <div className="font-mono-eyebrow text-black/40 text-[10px] mt-1">
                        {new Date(n.created_at).toLocaleDateString(undefined, {month:"short", day:"2-digit"})}
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationsBell;
